import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Table from "components/Table/Table.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Tooltip from '@material-ui/core/Tooltip';


// Icons
import Add from "@material-ui/icons/Add";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";

import { Auth, Discounts, Coupons } from "baseparking-api";

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    actionButton: {
        margin: "0 0 0 5px",
        padding: "5px",
        "& svg,& .fab,& .fas,& .far,& .fal,& .material-icons": {
            marginRight: "0px"
        },
        float: 'right'
    },
    addService: {
        float: 'right'
    },
    flex: {
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
    }
};



class DiscountsView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            discounts: [],
            coupons: [],
        }

    }

    componentWillMount() {
        this.refreshData();
    }

    refreshData = () => {
        Auth.authenticate('dagurleo@gmail.com', 'smegma123')
            .then(res => {
                Discounts.getClientDiscounts()
                    .then(res => {
                        this.setState({
                            loading: false,
                            discounts: res.data.discounts,
                        })
                    })
                    .catch(console.error)
                Discounts.getClientCoupons()
                    .then(res => {
                        this.setState({
                            loading: false,
                            coupons: res.data.coupons,
                        })
                        console.log(res.data);
                    })
                    .catch(console.error)
                Auth.isAuthenticated();
            })
    }

    deactivateDiscount = () => {
        console.log('deactivateDiscount');
    }
    editingDiscount = () => {
        console.log('editingDiscount');
    }

    deactivateCoupon = () => {
        console.log('deactivateCoupon');
    }
    editingCoupon = () => {
        console.log('editingCoupon');
    }

    render() {
        const { classes } = this.props;
        const { discounts, coupons } = this.state;

        const discountButtons = service => [
            { color: "danger", icon: Close, label: 'Óvirkja afslátt', function: this.deactivateDiscount },
            { color: "warning", icon: Edit, label: 'Breyta afslætti', function: this.editingDiscount },
        ].map((prop, key) => {
            return (
                <Tooltip title={prop.label}>
                    <Button color={prop.color} className={classes.actionButton} key={key} onClick={e => prop.function(service)}>
                        <prop.icon className={classes.icon} />
                    </Button>
                </Tooltip>
            );
        });

        const couponButtons = service => [
            { color: "danger", icon: Close, label: 'Óvirkja kóða', function: this.deactivateCoupon },
            { color: "warning", icon: Edit, label: 'Breyta kóða', function: this.editingCoupon },
        ].map((prop, key) => {
            return (
                <Tooltip title={prop.label}>
                    <Button color={prop.color} className={classes.actionButton} key={key} onClick={e => prop.function(service)}>
                        <prop.icon className={classes.icon} />
                    </Button>
                </Tooltip>
            );
        });

        // Formatting discounts list
        let discountsList = [];
        let discountsHeader = [];

        if (discounts.length) {
            discounts.map(s => {
                let list = Object.values(s).slice(1);
                list[3] = list[3] ? 'Virkur' : 'Óvirkur';
                if (!list[4]) list[4] = 'Ekki valið';
                if (!list[5]) list[5] = 'Ekki valið';
                // list.splice(3, 1);
                list.push(discountButtons(s));
                console.log(list);
                discountsList.push(list);
            })
            discountsHeader = ["Nafn", "Afsláttur %", "Hámarks fjöldi daga", "Virkur", "Virkur frá", "Virkur til", ""]
        }

        // Formatting coupons list
        let couponsList = [];
        let couponsHeader = [];

        if (coupons.length) {
            coupons.map(s => {
                let list = Object.values(s).slice(1);
                list.splice(1, 1);
                list[2] = list[2] ? 'Virkur' : 'Óvirkur';
                if (!list[3]) list[3] = 'Ekki valið';
                if (!list[4]) list[4] = 'Ekki valið';
                list.push(couponButtons(s));
                console.log(list);
                couponsList.push(list);
            })
            couponsHeader = ["Kóði", "Afsláttur %", "Virkur", "Virkur frá", "Virkur til", ""]
        }

        return (
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="info" className={classes.flex}>
                            <div>
                                <h4 className={classes.cardTitleWhite}>Afsláttarhópar</h4>
                                <p className={classes.cardCategoryWhite}>Afsláttarhópar hljóta % afslátt af fyrstu X mörgum dögum geymslunnar.</p>
                            </div>
                            <Button color="info" className={classes.addService} onClick={e => this.setState({ serviceDialog: true })}>Bæta við afsláttarhóp</Button>
                        </CardHeader>
                        <CardBody>
                            <Table
                                tableHeaderColor="primary"
                                tableHead={discountsHeader}
                                tableData={discountsList}
                            />
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                    <Card plain>
                        <CardHeader plain color="primary" className={classes.flex}>
                            <div>
                                <h4 className={classes.cardTitleWhite}>Afsláttakóðar</h4>
                                <p className={classes.cardCategoryWhite}>Afsláttarkóðar veita notendum % afslátt af heildarupphæð geymslunnar.</p>
                            </div>
                            <Button color="primary" className={classes.addService} onClick={e => this.setState({ serviceDialog: true })}>Bæta við afsláttarkóða</Button>
                        </CardHeader>
                        <CardBody>
                            <Table
                                tableHeaderColor="primary"
                                tableHead={couponsHeader}
                                tableData={couponsList}
                            />
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        )
    }
}

export default withStyles(styles)(DiscountsView);



// WEBPACK FOOTER //
// ./src/views/Discounts/Discounts.jsx